module.exports = __webpack_public_path__ + "img/FB_Info_Game_Page_1.9ea2baa1.png";